<template lang="pug">
  v-col(:style="styleBackground")
    slot
</template>

<script>
import { theme } from '@iez/core'
import { reactive, computed, toRefs } from '@vue/composition-api'

export default {
  setup () {
    const state = reactive({
      styleBackground: {
        borderRadius: `24px`,
        width: '100%',
        background: computed(() => theme.backgroundLight.color)
      }
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>